

export const FETCH_DOCUMENTS = 'FETCH_DOCUMENTS'
export const ADD_DOCUMENTS = 'ADD_DOCUMENTS'
export const UPDATE_DOCUMENTS = 'UPDATE_DOCUMENTS'
export const REMOVE_DOCUMENTS = 'REMOVE_DOCUMENTS'
export const GET_DOCUMENT = 'GET_DOCUMENT'

